module.exports = __webpack_public_path__ + "static/media/arm-robot.4ea8136f.jpg";